
import { PlanningUnassignedGridRow } from '@/entities/gridTables/model/planning/PlanningUnassignedGridRow'
import { planningUnassignedTablesSelector } from '@/entities/gridTables/selectors/planningUnassignedTablesSelector'
import { useAppSelector } from '@/shared/store'
import { EntityId } from '@reduxjs/toolkit'

export type PlanningUnassignedTableData = {
  rows: PlanningUnassignedGridRow[]
  isLoading: boolean
}

export const usePlanningUnassignedTableData = (scenarioId: EntityId): PlanningUnassignedTableData => {
  const planningUnassignedTable = useAppSelector(state => planningUnassignedTablesSelector.selectById(state, scenarioId))

  return {
    rows: planningUnassignedTable?.rows || [],
    isLoading: planningUnassignedTable?.isLoading || false,
  }
}
